import { createLucideIcon } from "lucide-react";

export const Copy = createLucideIcon(
    "Copy",
    [
        [
            "path",
            {
                d: "M8.6668 3.1427V2.6665C8.6668 1.5619 7.7713 0.6665 6.6668 0.6665H2.6668C1.5622 0.6665 0.6667 1.5619 0.6667 2.6665V7.3332C0.6667 8.4377 1.5622 9.3332 2.6668 9.3332H4.0001",
                key: "2snxis",
            },
        ],
        [
            "path",
            {
                d: "M9.3334 15.3332H13.3334C14.438 15.3332 15.3334 14.4377 15.3334 13.3332V8.6665C15.3334 7.5619 14.438 6.6665 13.3334 6.6665H9.3334C8.2288 6.6665 7.3334 7.5619 7.3334 8.6665V13.3332C7.3334 14.4377 8.2288 15.3332 9.3334 15.3332Z",
                key: "1vvk96",
            },
        ],
    ],
);
